import classnames from "classnames";

import { Label } from "../label";

import { twMerge } from "tailwind-merge";
import styles from "./Radio.module.scss";

interface IRadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  id?: string;
  label?: React.ReactNode;
  checked?: boolean;
  disabled?: boolean;
  error?: string | null;
  iconClassName?: string;
}

const Radio = ({
  className,
  id,
  label,
  checked,
  disabled,
  error,
  iconClassName,
  ...rest
}: IRadioProps) => {
  return (
    <div className={twMerge("tw-relative tw-pl-[28px]", className)}>
      <Label
        className={classnames(styles.label, { [styles.disabled]: disabled })}
        htmlFor={id}
      >
        <input
          {...rest}
          id={id}
          className={classnames(styles.input, "tw-absolute tw-invisible")}
          type="radio"
          checked={checked}
          disabled={disabled}
        />
        <div
          className={classnames(
            styles.icon,
            iconClassName,
            "tw-flex tw-absolute tw-justify-center tw-items-center tw-rounded-full",
            {
              [styles.error]: error,
              [styles.disabled]: disabled,
            },
          )}
        />
        <div>{label}</div>
      </Label>
    </div>
  );
};

export default Radio;
